export default __webpack_public_path__ + "static/6-832ac26debaf8e747a2b2ef1ad39f6d9.png";